// dateReducer.js
import { SET_START_DATE, SET_END_DATE } from '../action/dateActions';

const initialState = {
  startDate: '',
  endDate: '',
};

const dateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_START_DATE:
      return { ...state, startDate: action.payload };
    case SET_END_DATE:
      return { ...state, endDate: action.payload };
    default:
      return state;
  }
};

export default dateReducer;
